export default __webpack_public_path__ + "static/media/EM1920.34I-42950_-25654_0.683a19c9.jpg";